import { render } from "./UserLabelListSort.vue?vue&type=template&id=3601ba14&ts=true"
import script from "./UserLabelListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/components/UserLabelListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3601ba14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3601ba14', __exports__)) {
    api.reload('3601ba14', __exports__)
  }
  
  module.hot.accept("./UserLabelListSort.vue?vue&type=template&id=3601ba14&ts=true", () => {
    api.rerender('3601ba14', render)
  })

}


export default __exports__